import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { EDIT_MODELS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { EditModelsDataActionTypes, IEditModels } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadEditModels =
  (
    id: string,
    editModels: IEditModels,
  ): ThunkAction<Promise<void>, State, null, EditModelsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: EDIT_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadEditModels(id, editModels);
      dispatch({ type: EDIT_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: EDIT_MODELS + FAILURE, error });
    }
  };

export const editModelsIdle = () => ({ type: EDIT_MODELS + IDLE });
